// extracted by mini-css-extract-plugin
export default {"root":"classes_root__C3PE2","small":"classes_small__668b5","medium":"classes_medium__kk1bd","large":"classes_large__SBlZT"};